import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=545da197&scoped=true&"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js&"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545da197",
  null
  
)

export default component.exports